import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import styled, { css } from 'styled-components'

import Illustration from '../Illustration'

const baseContainerStyles = css`
  width: 100%;
  margin-inline: auto;
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
`

export const ContainerDesktop = styled(motion.create(Illustration))`
  ${baseContainerStyles}
  max-width: calc(100% - ${pxToRem(32)} * 2);
  @media ${mq(null, sizes.desktop)} {
    display: none;
  }
`

export const ContainerMobile = styled(Illustration)`
  ${baseContainerStyles}
  max-width: calc(100% - ${pxToRem(16)} * 2);
  @media ${mq(sizes.desktop)} {
    display: none;
  }
`
